import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 10.41V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41l9 9z"
}), 'CallMissedOutgoingTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CallMissedOutgoingTwoTone.js
// module id = 2609
// module chunks = 2